import {
  LayoutDashboard,
  Users,
  Car,
  CalendarDays,
  Wrench,
  Package,
  Truck,
  ShoppingCart,
  Receipt,
  FileText,
  UserCog,
  UserCircle,
  ShieldCheck,
  Mail,
  BarChart3,
  Settings,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Permission requise pour afficher l'entrée (contrôle affiné au Lot 2). */
  permission?: string;
}

/** Structure de navigation de la barre latérale (ordre = affichage). */
export const NAV_ITEMS: NavItem[] = [
  { label: 'Tableau de bord', to: '/', icon: LayoutDashboard },
  { label: 'Clients', to: '/clients', icon: Users, permission: 'customers:read' },
  { label: 'Véhicules', to: '/vehicules', icon: Car, permission: 'vehicles:read' },
  { label: 'Rendez-vous', to: '/rendez-vous', icon: CalendarDays, permission: 'appointments:read' },
  { label: 'Réparations', to: '/reparations', icon: Wrench, permission: 'repair_orders:read' },
  { label: 'Pièces / Stock', to: '/pieces', icon: Package, permission: 'parts:read' },
  { label: 'Fournisseurs', to: '/fournisseurs', icon: Truck, permission: 'suppliers:read' },
  { label: 'Achats', to: '/achats', icon: ShoppingCart, permission: 'purchases:read' },
  { label: 'Caisse / Ventes', to: '/ventes', icon: Receipt, permission: 'sales:read' },
  { label: 'Facturation', to: '/facturation', icon: FileText, permission: 'invoices:read' },
  { label: 'Employés', to: '/employes', icon: UserCog, permission: 'employees:read' },
  { label: 'Rapports', to: '/rapports', icon: BarChart3, permission: 'reports:read' },
  { label: 'Utilisateurs', to: '/utilisateurs', icon: UserCircle, permission: 'users:read' },
  { label: 'Rôles & permissions', to: '/roles', icon: ShieldCheck, permission: 'users:read' },
  { label: 'Messagerie', to: '/messagerie', icon: Mail, permission: 'settings:read' },
  { label: 'Paramètres', to: '/parametres', icon: Settings, permission: 'settings:read' },
];
